import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../setup/auth/authService';

const LoginPage = () => {
    const { t } = useTranslation();
    const { signinRedirect } = useAuth();

    useEffect(() => {
        signinRedirect();
    }, [signinRedirect]);

    return <p>{t('RedirectToLogin')}</p>;
};

export default LoginPage;
